import { Component, inject, ViewChild, OnDestroy, OnInit } from '@angular/core';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { TranslationService } from '../../core/services/translation.service';
import { Language } from '../../shared/models/language.model';
import { UpperCasePipe } from '@angular/common';

@Component({
  selector: 'app-language-selector',
  imports: [MatMenuModule, MatButtonModule, UpperCasePipe],
  templateUrl: './language-selector.component.html',
  styleUrl: './language-selector.component.css',
})
export class LanguageSelectorComponent implements OnInit, OnDestroy {
  private translationService = inject(TranslationService);

  @ViewChild(MatMenuTrigger) menuTrigger!: MatMenuTrigger;

  selectedLang!: Language;
  languages = [
    { code: 'en', label: 'English (US)', img: 'icons/engflag.svg' },
    { code: 'it', label: 'Italiano', img: 'icons/italyflag.svg' },
    { code: 'es', label: 'Español', img: 'icons/spainflag.svg' },
    { code: 'ar', label: 'العربية', img: 'icons/arabicflag.svg' },
    { code: 'fr', label: 'Français', img: 'icons/franceflag.svg' },
    { code: 'de', label: 'Deutsch', img: 'icons/germanyflag.svg' },
  ];

  private scrollListener = () => {
    if (this.menuTrigger?.menuOpen) {
      this.menuTrigger.closeMenu();
    }
  };

  ngOnInit() {
    const lang = this.translationService.uiLang();
    this.selectedLang =
      this.languages.find((l) => l.code === lang) || this.languages[0];

    window.addEventListener('scroll', this.scrollListener, true);
  }

  selectLanguage(lang: Language) {
    this.selectedLang = lang;
    this.translationService.setUiLang(lang.code);
  }

  ngOnDestroy() {
    window.removeEventListener('scroll', this.scrollListener, true);
  }
}
